import { apiSlice } from "@/shared/api/api-slice"
import type { CreateSubscriptionRequest, CreateSubscriptionResponse } from "@/shared/types/api/business-mode.types"

import { mapBusinessSubscriptionError } from "./error-mapping"

export const createSubscriptionApi = apiSlice
  .enhanceEndpoints({
    addTagTypes: ["BusinessSubscription", "BusinessUsageStats", "GroupRating"]
  })
  .injectEndpoints({
    endpoints: builder => ({
      createBusinessSubscription: builder.mutation<CreateSubscriptionResponse, CreateSubscriptionRequest>({
        query: body => ({
          url: "/api/v1/business/subscriptions",
          method: "POST",
          body
        }),
        transformErrorResponse: mapBusinessSubscriptionError,
        invalidatesTags: [
          { type: "BusinessSubscription" as const },
          { type: "BusinessUsageStats" as const },
          { type: "GroupRating" as const }
        ],
        async onQueryStarted(_arg, { dispatch, queryFulfilled }) {
          try {
            await queryFulfilled

            // Invalidate tags with retry pattern (eventual consistency)
            const tags = ["GroupRating", "BusinessSubscription", "BusinessUsageStats"] as const

            dispatch(createSubscriptionApi.util.invalidateTags([...tags]))
            setTimeout(() => {
              dispatch(createSubscriptionApi.util.invalidateTags([...tags]))
            }, 1000)
            setTimeout(() => {
              dispatch(createSubscriptionApi.util.invalidateTags([...tags]))
            }, 2500)
          } catch {
            // Error already handled by mutation
          }
        }
      })
    })
  })

export const { useCreateBusinessSubscriptionMutation } = createSubscriptionApi
